<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div v-if="process_statuses.length > 0">
        <ExpandingSegment v-for="(process_status, i) in process_statuses" :key="i" class="my-3">
            <template slot="header">
                <v-row align="center" align-content="center">
                    <v-progress-circular
                        v-if="processing_invoices_count(process_status).value >= 1"
                        :width="3"
                        color="green"
                        indeterminate
                        size="25"
                    >
                    </v-progress-circular>
                    <div v-if="error_invoices_count(process_status).value > 0" class="subheading pl-3">
                        <span v-if="is_error_type(process_status) && process_status === 'error_calculate_invoice'">
                            {{ $t("Error in calculating invoice") }}
                        </span>
                        <span v-if="is_error_type(process_status) && process_status === 'error_import_invoice'">
                            {{ $t("Error in importing invoice") }}
                        </span>
                        <span v-if="is_error_type(process_status) && process_status === 'error_create_invoice'">
                            {{ $t("Error in creating invoice") }}
                        </span>
                        <span v-if="is_error_type(process_status) && process_status === 'error_export_invoice'">
                            {{ $t("Error in exporting invoice") }}
                        </span>
                        <span v-if="is_error_type(process_status) && process_status === 'error_send_invoice'">
                            {{ $t("Error in sending invoice") }}
                        </span>
                        ({{ error_invoices_count(process_status).value }})
                    </div>
                    <div v-if="processing_invoices_count(process_status).value > 0" class="subheading pl-3">
                        <span style="color: var(--v-gray-darken3);">
                            <span v-if="!is_error_type(process_status) && process_status === 'calculate_invoice'">
                                {{ $t("Calculating invoice") }}
                            </span>
                            <span v-if="!is_error_type(process_status) && process_status === 'create_invoice'">
                                {{ $t("Creating invoice") }}
                            </span>
                            <span v-if="!is_error_type(process_status) && process_status === 'export_invoice'">
                                {{ $t("Exporting invoice") }}
                            </span>
                            <span v-if="!is_error_type(process_status) && process_status === 'import_invoice'">
                                {{ $t("Importing invoice") }}
                            </span>
                            <span v-if="!is_error_type(process_status) && process_status === 'send_invoice'">
                                {{ $t("Sending invoice") }}
                            </span>
                            ({{ processing_invoices_count(process_status).value }})
                        </span>
                    </div>
                </v-row>
            </template>
            <template slot="closed-actions">
                <v-btn color="primary" text> {{ $t("Show") }}</v-btn>
            </template>
            <template slot="open-actions">
                <v-btn
                    v-if="error_invoices_count(process_status).value > 0"
                    color="primary"
                    text
                    @click.stop.prevent="onClearErrorsClick(process_status)"
                >
                    {{ $t("Clear errors") }}
                </v-btn>
                <v-btn
                    v-if="processing_invoices_count(process_status).value > 0"
                    color="primary"
                    text
                    @click.stop.prevent="onUpdateTotals()"
                >
                    {{ $t("Refresh") }}
                </v-btn>
                <v-btn icon color="grey">
                    <v-icon>close</v-icon>
                </v-btn>
            </template>

            <v-data-table
                v-model="selected_in_process_invoices"
                :options.sync="table_options"
                :headers="table_props.headers"
                :items="in_process_invoices(process_status)"
                :items-per-page="-1"
                hide-default-footer
                hide-default-header
                :loading="table_props.isLoading"
                class="elevation-2 medium-dense-table"
                :show-select="is_error_type(process_status) && can_edit_account(selectedAccount.id)"
                item-key="id"
            >
                <template v-slot:header="{ props, on }">
                    <thead class="v-data-table-header">
                        <tr>
                            <th
                                v-for="(header, index) in props['headers']"
                                :key="index"
                                :class="[formatTableHeaderClass(header, props['options'])]"
                                :width="header.width"
                                role="columnheader"
                                scope="col"
                                v-on="on"
                                @click="
                                    header.sortable !== false && header['value'] !== 'data-table-select'
                                        ? changeTableSort(header.value)
                                        : ''
                                "
                            >
                                <v-simple-checkbox
                                    v-if="header['value'] === 'data-table-select'"
                                    color="primary"
                                    :indeterminate="props.someItems && !props.everyItem"
                                    :value="props.everyItem"
                                    @input="on['toggle-select-all'](!props.someItems)"
                                />
                                <span v-else class=" subtitle-2">
                                    {{ header.text }}
                                </span>
                                <v-icon v-if="header.value === table_options.sortBy">
                                    {{ table_options.sortDesc ? "mdi-menu-down" : "mdi-menu-up" }}
                                </v-icon>
                            </th>
                        </tr>
                    </thead>
                </template>
                <template v-slot:item="{ item, select, isSelected, index }">
                    <tr
                        :key="item.id"
                        :class="isSelected ? 'v-data-table__selected' : ''"
                        @click="onInvoiceRowClick($event, item, false)"
                        @click.middle="onInvoiceRowClick($event, item, true)"
                    >
                        <td v-if="is_error_type(process_status) && can_edit_account(selectedAccount.id)">
                            <v-simple-checkbox color="primary" :value="isSelected" @input="select" />
                        </td>
                        <td v-for="(header, j) in table_props.headers" :key="'td_' + j" :class="'text-' + header.align">
                            <div :class="header.class" class="main--text body-2">
                                <span v-if="header.value === 'avatar'">
                                    <AccountAvatar
                                        size="31"
                                        tile
                                        :initials="item.client.client_initials"
                                        :color="item.client.color"
                                    />
                                </span>
                                <span v-else-if="header.value === 'client.name'">
                                    <span v-if="item.client" class="company-name mr-0">
                                        {{ item.client.name }}
                                    </span>
                                    <span v-else>-</span>
                                </span>
                                <span v-else-if="header.value === 'period_label'">
                                    <span v-if="item.period_label">
                                        {{ item["period_label"] | format_period_label }}
                                    </span>
                                </span>
                                <span v-else-if="header.value === 'due_date'">
                                    {{ item["due_date"] | format_date }}
                                </span>
                                <span v-else-if="header.value === 'net_sum'" class="text-right font-weight-medium">
                                    {{ parseFloat(item["net_sum"]) | format_money(item.currency) }}
                                </span>
                                <div v-else-if="header.value === 'status'" class="text-right d-inline-flex align-center">
                                    <DotStatus
                                        :color="getStatusColorMap(item.status, item.process_status).color"
                                        :text="getStatusColorMap(item.status, item.process_status).text"
                                    />
                                    <v-tooltip bottom max-width="250" v-if="getProcessErrorMessageForInvoice(item)">
                                        <template v-slot:activator="{ on }">
                                            <div v-on="on">
                                                <icon icon="AlertTriangle" small class="ml-1" color="error" />
                                            </div>
                                        </template>
                                        <span>{{ getProcessErrorMessageForInvoice(item) }}</span>
                                    </v-tooltip>
                                </div>
                                <span v-else>
                                    {{ item[header.value] }}
                                </span>
                            </div>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </ExpandingSegment>
    </div>
</template>

<script>
import { Router } from "../../composables/Router";
import { $t } from "@/i18n";
import AccountAvatar from "../../components/AccountAvatar";
import DotStatus from "../../components/DotStatus";
import ExpandingSegment from "../../components/ExpandingSegment";
import RightsModule from "../../composables/use-rights";
import { computed, ref, toRefs, reactive } from "@vue/composition-api";
import { useTable } from "../../composables/use-table";
import SalesInvoiceModule from "@/store/modules/sales_invoice";
import errorDialog from "@/views/ErrorDialog/errorDialog"

export default {
    name: "SalesInvoiceListProgress",
    components: {
        AccountAvatar,
        ExpandingSegment,
        DotStatus
    },
    props: {
        selectedAccount: {
            type: Object,
            default: null
        },
        salesInvoices: {
            type: Array,
            required: true
        },
        getStatusColorMap: {
            type: Function,
            default: null
        },
        updateTotals: {
            type: Function,
            default: null
        }
    },
    setup(props) {
        const router = Router();
        const { table_options, table_footer_props, changeTableSort, formatTableHeaderClass } = useTable();
        const { can_edit_account } = RightsModule();
        const { clearProcessErrors, getProcessErrorMessageForInvoice } = SalesInvoiceModule();
        const state = reactive({
            table_props: {
                items: [],
                loading: true,
                headers: [
                    { text: "", value: "avatar", align: "left pl-1 pr-1", sortable: false, width: 31, removable: false },
                    { text: $t("Client"), value: "client.name", align: "left", width: "200px" },
                    { text: $t("Period"), value: "period_label", align: "left" },
                    { text: $t("Invoice #"), value: "invoice_number", align: "left" },
                    { text: $t("Due date"), value: "due_date", align: "left" },
                    { text: $t("Net"), value: "net_sum", align: "right", class: "text-right" },
                    { text: $t("Status"), value: "status", align: "right", class: "text-right", sortable: false }
                ],
                row_items: [15, 30, 60, { "text": "All", "value": -1 }],
                hide_headers: false
            }
        });
        const selected_in_process_invoices = ref([]);

        const process_statuses = computed(() => {
            return props.salesInvoices.reduce((carry, item) => {
                if (item["process_status"] && !~carry.indexOf(item["process_status"])) {
                    carry.push(item["process_status"]);
                }
                return carry;
            }, []);
        });
        const in_process_invoices = process_status => {
            return props.salesInvoices.filter(invoice => invoice.process_status === process_status).reverse();
        };
        const processing_invoices_count = process_status =>
            computed(() => {
                let x = Array.from(props.salesInvoices).filter(invoice => {
                    return invoice.process_status === process_status && process_status.indexOf('error_') === -1;
                });
                return x.length;
            });

        const error_invoices_count = process_status =>
            computed(() => {
                let x = Array.from(props.salesInvoices).filter(invoice => {
                    return invoice.process_status === process_status && process_status.indexOf('error_') === 0;
                });
                return x.length;
            });

        const is_error_type = process_status => {
            return process_status.includes("error_");
        };
        const onInvoiceRowClick = (event, invoice, middle) => {
            if (event.ctrlKey || event.metaKey || middle) {
                if (!invoice.id) {
                    return window.open(
                        "/invoices/-1?period_label=" +
                            invoice.period_label +
                            "&" +
                            "client_id=" +
                            invoice.client_id
                    );
                } else {
                    return window.open("/invoices/" + invoice.id);
                }
            } else {
                if (!invoice.id) {
                    return router.push({
                        path: "/invoices/-1",
                        query: { period_label: invoice.period_label, client_id: invoice.client_id }
                    });
                } else {
                    return router.push("/invoices/" + invoice.id);
                }
            }
        };
        const onUpdateTotals = function () {
            selected_in_process_invoices.value = [];
            props.updateTotals();
        }
        const onClearErrorsClick = async process_status => {
            let clear_invoice_id_list = [];
            // if nothing is selected, select all to make it easier on user
            if(!selected_in_process_invoices.value || selected_in_process_invoices.value.length === 0) {
                selected_in_process_invoices.value = props.salesInvoices
                // this what we, in the industry, call UX
                await new Promise(resolve => {
                    setTimeout(resolve, 200);
                })
            }
            const selectedInvoiceIds = Array.from(selected_in_process_invoices.value, (item) => item.id)
            for (let invoice of Array.from(props.salesInvoices).filter((i) => selectedInvoiceIds.includes(i.id))) {
                if (invoice.process_status === process_status && process_status.indexOf('error_') === 0) {
                    clear_invoice_id_list.push(invoice.id)
                }
            }
            // console.log(clear_invoice_id_list);
            clearProcessErrors(props.selectedAccount.id, clear_invoice_id_list)
                .then(function () {
                    selected_in_process_invoices.value = [];
                    onUpdateTotals();
                })
                .catch(ex => errorDialog.showError(ex));
        };

        return {
            ...toRefs(state),
            can_edit_account,
            process_statuses,
            selected_in_process_invoices,
            processing_invoices_count,
            error_invoices_count,
            is_error_type,
            table_options,
            table_footer_props,
            changeTableSort,
            formatTableHeaderClass,
            in_process_invoices,
            onInvoiceRowClick,
            onClearErrorsClick,
            onUpdateTotals,
            getProcessErrorMessageForInvoice
        };
    }
};
</script>
